<template>
  <v-card class="d-flex">
    <v-card-text>
<!--      <pre>{{ query }}</pre>-->
<!--      <pre>{{ offer }}</pre>-->
      <div><b>Denumire furnizor:</b> <a :href="offer.legatura_oferta" class="ml-2">{{ offer.furnizor.nume_furnizor }}</a></div>
      <div><b>Denumire ofertă:</b> <a :href="offer.oferta_pdf" class="ml-2">{{ offer.denumire_oferta }}</a></div>
      <div><b>Tip ofertă:</b> {{ offer.tip_oferta }}</div>
      <div><b>Energie regenerabilă:</b> {{ offer.procent_energie_surse_regenerabile }}</div>
      <div><b>Valoare factură (lei):</b> {{ offer.valoare_factura_furnizor_fc }}</div>
      <div><b>Valoare unitară factură (lei/kwh):</b> {{ offer.pret_final }}</div>
      <div><b>Rezultat comparatie valoare factura oferta tip - valoare factura curenta (%):</b> <span :class="`${rezultat_comparatie_valoare_factura_color}--text`">{{ rezultat_comparatie_valoare_factura }}</span></div>
      <div><b>Economie/Cost suplimentar lunar (lei):</b> <span :class="`${rezultat_economie_cost_color}--text`">{{ rezultat_economie_cost }}</span></div>

      <v-expansion-panel class="mt-2">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Vezi detalii</div>
          </template>
          <v-card>
            <v-card-text>
              <div><b>Tip oferta:</b> {{ offer.tip_oferta }}</div>
              <div><b>Tip produs:</b> {{ offer.tip_produs }}</div>
              <div><b>Tip client caruia i se adreseaza oferta:</b> {{ offer.tip_client }}</div>
              <div><b>Tip pret oferta:</b> {{ offer.tip_pret_oferta }}</div>
              <div><b>Valabilitatate oferta:</b> {{ valabilitate_oferta }}</div>
              <div><b>Perioada de aplicare:</b> {{ perioada_de_aplicare }}</div>
              <v-divider class="mt-4 mb-4"/>
              <div><b>Preţ de furnizare: {{ pret_de_furnizare.toFixed(5) }} (lei/kWh), din care:</b></div>
              <div> - Pret energie - inclusiv Tg (lei/kWh): {{ offer.pret_energie }}</div>
              <div> - Tarif transport TL (lei/kWh): {{ offer.tarif_transport_tl }}</div>
              <div> - Tarif serviciu sistem (lei/kWh): {{offer.tarif_serviciu_sistem }}</div>
              <div> - Tarif serviciu distributie (lei/kWh): {{ offer.tarif_serviciu_distributie }}</div>
              <div><b>Valoare componenta fixa (lei/zi):</b> {{ offer.valoare_componenta_fixa }}</div>
              <div><b>Taxa cogenerare inalta eficienta (lei/kWh):</b> {{ offer.taxa_cogenerare_inalta_eficienta }}</div>
              <div><b>Contravaloare certificate verzi (lei/kWh):</b> {{ offer.contravaloare_certificate_verzi }}</div>
              <div><b>Acciza (lei/kWh):</b> {{ offer.acciza }}</div>
              <div><b>TVA (%):</b> {{ offer.tva }}</div>
              <div><b>Valoare unitară factură (lei/kWh):</b> {{ offer.pret_final }}</div>
              <v-divider class="mt-4 mb-4"/>
              <div><b>Perioada contract:</b> {{ offer.perioada_contract }}</div>
              <div><b>Termen de plata:</b> {{ offer.termen_plata }}</div>
              <div><b>Mod transmitere factura:</b> {{ offer.mod_transmitere_factura }}</div>
              <div><b>Frecventa emitere factura:</b> {{ offer.frecventa_emitere_factura }}</div>
              <div><b>Frecventa citire contor:</b> {{ offer.frecventa_citire_contor }}</div>
              <div><b>Model contract:</b> <a :href="model_contract" title="Descarca" class="ml-2">Descarca</a></div>
              <div><b>Alte costuri:</b> {{ offer.alte_costuri }}</div>
              <div><b>Structura achizitie energie electrica in anul 2022:</b> </div>
              <div> - Gaz: {{ offer.structura_achizitie_energetica.gaz }}</div>
              <div> - Hidro: {{ offer.structura_achizitie_energetica.hidro }}</div>
              <div> - Nucleara: {{ offer.structura_achizitie_energetica.nucleara }}</div>
              <div> - Vant: {{ offer.structura_achizitie_energetica.vant }}</div>
              <div> - Solar: {{ offer.structura_achizitie_energetica.solar }}</div>
              <div> - Altele: {{ offer.structura_achizitie_energetica.altele }}</div>
              <div><b>Reduceri aplicate:</b> {{ offer.reduceri }}</div>
              <div><b>Perioada de aplicare a reducerii:</b> {{ perioada_reduceri }}</div>
              <div><b>Servicii aditionale incluse:</b> {{ offer.servicii_aditionale_incluse }}</div>
              <div><b>Alte conditii:</b> {{ offer.alte_conditii }}</div>
              <div><b>Ultima actualizare:</b> {{ offer.ultima_actualizare }}</div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mt-2">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Informatii contractare</div>
          </template>
          <v-card>
            <v-card-text>
              <template v-for="grup_documente in documente_grupate">
                <h3 class="mb-2 mt-2">{{ grup_documente.label }}</h3>
                <template v-for="document in grup_documente.items">
                  <div v-if="document.fisier" :key="document.id_document">
                    <a :href="`https://posf.ro/comparator/files/contracte/${document.fisier}`" class="mr-2">Descarca</a> {{ document.nume }}
                  </div>
                </template>
              </template>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import langs from '../../modules/electric/lang/index';

export default {
  props: {
    offer: Object,
    query: Object
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    pret_de_furnizare () {
      return (parseFloat(this.offer.pret_energie) +
        parseFloat(this.offer.tarif_transport_tl) +
        parseFloat(this.offer.tarif_serviciu_sistem) +
        parseFloat(this.offer.tarif_serviciu_distributie));
    },
    model_contract () {
      const baseUrl = 'https://posf.ro/comparator/files/furnizori/'
      return this.offer.model_contract.length > 0 ? `${baseUrl}/${this.offer.model_contract[0]}` : '#'
    },
    perioada_reduceri () {
      if (!this.offer.perioada_reduceri_min || !this.offer.perioada_reduceri_max) {
        return '';
      }
      return `${this.offer.perioada_reduceri_min} - ${this.offer.perioada_reduceri_max}`
    },
    valabilitate_oferta () {
      if (!this.offer.valabilitate_oferta_start || !this.offer.valabilitate_oferta_stop) {
        return '';
      }
      return `${this.offer.valabilitate_oferta_start} - ${this.offer.valabilitate_oferta_stop}`
    },
    perioada_de_aplicare () {
      if (!this.offer.perioada_de_aplicare_start || !this.offer.perioada_de_aplicare_stop) {
        return '';
      }
      return `${this.offer.perioada_de_aplicare_start} - ${this.offer.perioada_de_aplicare_stop}`
    },
    rezultat_comparatie_valoare_factura() {
      const lang = langs[this.language];
      return this.query.valoare_factura_curenta ?
        this.offer.rezultat_comparatie_valoare_factura
        : lang.completati_factura_curenta
    },
    rezultat_comparatie_valoare_factura_color () {
      return this.rezultat_comparatie_valoare_factura <= 0 ? 'green' : 'red'
    },
    rezultat_economie_cost() {
      const lang = langs[this.language];
      return this.query.valoare_factura_curenta ?
        this.offer.rezultat_economie_cost
        : lang.completati_factura_curenta
    },
    rezultat_economie_cost_color () {
      return this.rezultat_economie_cost.indexOf('-') !== -1 ? 'green' : 'red'
    },
    documente_grupate () {
      const lang = langs[this.language];
      const documente_grupate = {
        client_nou: {
          label: lang.documente_client_nou_label,
          items: []
        },
        client_furnizor_existent: {
          label: lang.documente_client_furnizor_existent,
          items: []
        },
        client_furnizor_nou: {
          label: lang.documente_client_furnizor_nou,
          items: []
        },
      };
      const documente = this.offer.documente.filter(doc => doc.fisier && doc.tip_document);
      for (const document of documente) {
        if (document.tip_document.indexOf('client_nou') === 0) {
          documente_grupate.client_nou.items.push(document);
        } else if (document.tip_document.indexOf('client_furnizor_existent') === 0) {
          documente_grupate.client_furnizor_existent.items.push(document);
        } else if (document.tip_document.indexOf('client_furnizor_nou') === 0) {
          documente_grupate.client_furnizor_nou.items.push(document);
        } else if (document.tip_document.indexOf('model_contract') === 0) {
          // whatever
        } else {
          console.log(`Unable to classify document for ${this.offer.nume_oferta}: ${document.nume} (${document.tip_document})`);
        }
      }
      return documente_grupate;
    }
  }
}
</script>
